/**
 * Ограничение почты ру-зоной (.ru, .su, .рф).
 * Действует на регистрацию и смену почты в профиле; серверная проверка
 * (backend/api/v1/register.py, POST /register/start) — источник истины.
 */

const RU_EMAIL_ZONES = [".ru", ".su", ".рф", ".xn--p1ai"]

/**
 * Разрешён ли домен письма (регистрация/смена почты)
 * @param {string} email
 * @returns {boolean}
 */
export function isRuZoneEmail(email) {
  const domain = String(email || "")
    .trim()
    .toLowerCase()
    .split("@")
    .pop()
    .replace(/\.$/, "")
  return RU_EMAIL_ZONES.some((z) => domain === z.slice(1) || domain.endsWith(z))
}

export const EMAIL_ZONE_MESSAGE =
  "Регистрация доступна только с почтовых адресов в доменах .ru, .su и .рф. Пожалуйста, укажите другую почту."
